module.exports = __webpack_public_path__ + "img/add-new-icon.8fe211f1.svg";